import React from 'react'
import styled from 'styled-components'

const InlineTitleWrap = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  position: relative;
`
const InlineTitleText = styled.div`
  background: ${({ theme }) => theme.colors.black};
  clip-path: polygon(0% 100%, calc(100% - 30px) 100%, 100% 0%, 0% 0%);
  color: ${({ theme }) => theme.colors.white};
  margin-right: 30px;
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  font-size: 120%;
`
const InlineTitleDecor = styled.div`
  background: ${({
    theme: {
      colors: { teal },
    },
  }) => teal};
  clip-path: polygon(100% 100%, 0% 100%, calc(100% - 20px) 0%, 100% 0%);
  height: 100%;
  position: absolute;
  right: 0;
  width: 50px;
`

const InlineTitle = ({ title }) => {
  return (
    <InlineTitleWrap>
      <InlineTitleText>{title}</InlineTitleText>
      <InlineTitleDecor />
    </InlineTitleWrap>
  )
}

export default InlineTitle
